
























































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import Aselect from '@/components/commonForm/select/index.vue'
import widgetCommon from './widgetCommon'
import widgetaPop from './widgetPop'
@Component({
  components: {
    // Aselect
  }
})
export default class extends Mixins(widgetCommon, widgetaPop) {
  public get value () {
    let v = this.form[this.item.businessId] || []
    return v.length ? '1' : ''
  }
  private get currentCheckbox () {
    if (!this.form[this.item.businessId]) {
      return []
    }
    if (!this.form[this.item.businessId].length) {
      return []
    }
    return this.item.options.filter((option) => {
      return this.form[this.item.businessId].includes(option.key) 
    })
  }
  private popupValue: number[] = []
  public initField () {
    if (this.isUndef(this.form[this.item.businessId])) {
      this.form[this.item.businessId] = this.item.defaultValue || []
    }
  }
  public mounted () {
    if (this.type.includes('record')) {
       this.initField()
    }
  }
  private comfirm () {
    this.form[this.item.businessId] = [...this.popupValue]
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.changeStatus(true)
    this.popupValue = [...this.form[this.item.businessId]]
  }
  private clear () {
    this.popupValue = []
  }
}
